import uploadFileAPI from '@application/api/endpoints/file-api';
import { fileUploadStart, fileUploadSuccess, fileUploadFailure } from '../reducers/fileReducer';
export const uploadFileAction = (folderName, file) => async (dispatch) => {
    dispatch(fileUploadStart());
    try {
        const response = await uploadFileAPI.uploadFile(folderName, file);
        dispatch(fileUploadSuccess(response));
        return response;
    }
    catch (error) {
        dispatch(fileUploadFailure('File upload failed'));
    }
};
